import React from 'react';
import { TableCell as MuiTableCell } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';
import { darken, alpha, lighten } from '@mui/material/styles';

const useStyles = makeStyles(theme => ({
  tableCell: {
    borderLeft: `1px solid
    ${
      theme.palette.mode === 'light'
        ? lighten(alpha(theme.palette.divider, 1), 0.97)
        : darken(alpha(theme.palette.divider, 1), 0.68)
    }`,
  },
}));

const TableCell = ({ children, className, noLeftBorder, ...rest }) => {
  const classes = useStyles();
  return (
    <MuiTableCell
      className={classNames(className, { [classes.tableCell]: !noLeftBorder })}
      {...rest}
    >
      {children}
    </MuiTableCell>
  );
};

export default TableCell;
